import { render, staticRenderFns } from "./IndexContent.vue?vue&type=template&id=3ce3d2a7&scoped=true&"
import script from "./IndexContent.vue?vue&type=script&lang=js&"
export * from "./IndexContent.vue?vue&type=script&lang=js&"
import style0 from "./IndexContent.vue?vue&type=style&index=0&id=3ce3d2a7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ce3d2a7",
  null
  
)

export default component.exports